export enum COLLECTIONS_ACTIONS {
  getTenantCollections = 'collections/getTenantCollections',
  getCollection = 'collections/getCollection',
  createCollection = 'collections/createCollection',
  updateCollection = 'collections/updateCollection',
  archiveCollection = 'collections/archiveCollection'
}
